import React, { memo } from 'react'
import cx from 'classnames'
import { Typography, Button, ButtonBase } from '@material-ui/core'
import { mountUrl, replaceImagePath, getElasticFieldNameByLanguage } from '~/utils'
import { useLiterals } from '~/components/Literals'
import ImagePlaceholder from '~/components/ImagePlaceholder'
import imageNotFound from '~/assets/imageNotFound.svg'

function ProductCard({ product, language, classes, onProductClick }) {
  const image = replaceImagePath(product, language)
  const { getLiteral } = useLiterals()

  return (
    <ButtonBase className={classes.product} onClick={() => onProductClick(product)}>
      <div className={classes.img}>
        {image ? (
          <ImagePlaceholder
            src={mountUrl(image, { width: 120, height: 300 })}
            placeholder={mountUrl(image, { height: 50 })}
          >
            {(src, loading) => (
              <img
                src={src}
                alt={product[getElasticFieldNameByLanguage(language, 'name')]}
                className={cx(classes.productImage, {
                  [classes.productImageLoading]: loading,
                })}
              />
            )}
          </ImagePlaceholder>
        ) : (
          <img src={imageNotFound} alt="" className={classes.imageMissing} />
        )}
      </div>

      <div className={classes.texts}>
        <Typography className={classes.text} variant="subtitle2">
          {product[getElasticFieldNameByLanguage(language, 'name')]}
        </Typography>
        <Typography className={classes.text} variant="caption">
          {product[getElasticFieldNameByLanguage(language, 'description')]}
        </Typography>
        <Button component="span" className={classes.rightIcon}>
          {getLiteral('1513')}
        </Button>
      </div>
    </ButtonBase>
  )
}

export default memo(ProductCard)
